import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic'

type BaseInputProps = {
  label: string
  name: string
  hint?: string
  error?: string
  required?: boolean
  modelValue?: string | number
  /** Bump this on every validation attempt to re-flash the error even when its text hasn't changed. */
  attempt?: number
}

export type InputProps = BaseInputProps & {
  // Applied to the native input only, so the testid is not duplicated on the wrapper.
  inputTestId?: string
  readonly?: boolean
}

type Option = {
  label: string
  value: string | number
}

export type Options = Option[]

export type CheckboxProps = BaseInputProps & {
  default?: string
  swatch?: ShopperProductsTypes.VariationAttribute
  // Lands on the <label>. Swatch checkboxes hide their input, so the label is the only handle.
  testId?: string
}

export type SelectProps = CheckboxProps & {
  options: Options
  // Applied to the native select only, so the testid is not duplicated on the wrapper.
  selectTestId?: string
}

export function getMessageIDs(name: string) {
  return {
    hintId: `hint-id-${name}`,
    errorId: `error-id-${name}`,
  }
}

export function getAriaIDs({ name, error, hint }: { name: string; error?: string; hint?: string }) {
  const { hintId, errorId } = getMessageIDs(name)

  let ariaIds = error ? `${errorId} ` : ''
  ariaIds += hint ? hintId : ''

  return ariaIds
}
